import { lazy } from "react";

const StampApply = lazy(() => import("../pages/weddingStamp/Apply"));
const StampPartners = lazy(() => import("../pages/weddingStamp/Partners"));
const StampApplyComplete = lazy(() => import("../pages/weddingStamp/ApplyComplete"));
const ApplyEletronics = lazy(() => import("../pages/weddingStamp/ApplyEletronics"));

export const weddingStampRoutes = [
  { path: "/weddingStamp/partners", element: <StampPartners /> },
  { path: "/weddingStamp/apply", element: <StampApply /> },
  { path: "/weddingStamp/apply/complete", element: <StampApplyComplete /> },
  { path: "/weddingStamp/eletronics/apply", element: <ApplyEletronics /> },
];
